import { render, staticRenderFns } from "./card-review.vue?vue&type=template&id=fcb5468c&scoped=true&"
import script from "./card-review.vue?vue&type=script&lang=js&"
export * from "./card-review.vue?vue&type=script&lang=js&"
import style0 from "./card-review.vue?vue&type=style&index=0&id=fcb5468c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb5468c",
  null
  
)

export default component.exports